import React from 'react';
import Button from './Button';
import { Badge, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/studentAppTheme';
import { getUppercaseLetter } from '@monorepo/shared/src/util/text-util';
import { AppRoutes } from '@monorepo/shared/src/types';

type Props = {
  redirectRoute?: { title?: AppRoutes; path: string };
  ariaLabel?: string;
  character: string;
  showCheckIcon?: boolean;
  disabled?: boolean;
};

const CharacterBadgeButton: React.FC<Props> = ({
  redirectRoute,
  ariaLabel,
  character,
  showCheckIcon,
  disabled,
}) => {
  const classes = useStyles();

  const renderCharacter = (
    <Typography className={classes.character}>{getUppercaseLetter(character)}</Typography>
  );
  return (
    <Badge
      invisible={!showCheckIcon}
      classes={{ badge: classes.selectedBadge }}
      badgeContent={<FontAwesomeIcon className={classes.checkIcon} icon={faCheck} />}
    >
      <Button disabled={disabled} aria-label={ariaLabel} redirectRoute={redirectRoute} size="small">
        {renderCharacter}
      </Button>
    </Badge>
  );
};

const useStyles = makeStyles((theme) => ({
  character: {
    color: 'black',
    fontSize: theme.typography.pxToRem(30),
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    paddingTop: remCalc(8),
  },
  selectedBadge: {
    width: remCalc(30),
    height: remCalc(30),
    right: '50%',
    top: -5,
    boxShadow: '0 0 3px 0 rgb(0 0 0 / 50%)',
    border: '2px solid #FFFFFF',
    borderRadius: '50%',
    backgroundColor: '#279451',
  },
  checkIcon: {
    color: 'white',
    fontSize: theme.typography.pxToRem(13),
  },
}));

export default CharacterBadgeButton;
